export const SECTION_LG_MAX_W = "max-w-[1500px] px-3 md:px-12 mx-auto";
export const SECTION_MD_MAX_W = "max-w-5xl px-3 md:px-12 mx-auto";
